import { render, staticRenderFns } from "./PledgeLetter.vue?vue&type=template&id=04d1929b&scoped=true"
import script from "./PledgeLetter.vue?vue&type=script&lang=js"
export * from "./PledgeLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1929b",
  null
  
)

export default component.exports